/**
 * @type AttributeHandler 
 */
const noopAttr = {

    target: '*',

    test: /^(?:model|convert|channel|on-init)/i,

    handle: ()=> {},
    parse: ()=> []
};

export default noopAttr;



// WEBPACK FOOTER //
// ./src/dom/attribute-manager/attributes/no-op-attr/index.js